import { IconButton, Icons, Box } from '@cast/design-system';
import { SelectionTemplateTaintEffect } from '@cast/types';

import {
  InputsStack,
  RffInput,
  RffSelect,
  WhenMode,
} from '@cast/shared-rff-ui';

type CustomTaintsStackProps = {
  disabled: boolean;
};

export const CustomTaintsStack = ({ disabled }: CustomTaintsStackProps) => {
  return (
    <InputsStack
      sx={{ '& .RffInputsArray-rows': { gap: 10, ml: 24 } }}
      name="_customTaints"
      addRowButtonTestId="taint-pair-add-button"
      renderInputsRow={({ index, remove, isOnly }) => {
        return (
          <Box
            display="grid"
            gridTemplateColumns="1fr 1fr 109px 32px"
            columnGap={8}
          >
            <RffInput
              size="small"
              testId={`taint-pair-${index}-key-input`}
              disabled={disabled}
              name={`_customTaints[${index}].key`}
              label="Key"
              placeholder="e.g. environment"
            />
            <RffInput
              size="small"
              testId={`taint-pair-${index}-value-input`}
              disabled={disabled}
              name={`_customTaints[${index}].value`}
              label="Value"
              placeholder="e.g. development"
            />
            <RffSelect
              size="sm"
              testId={`taint-pair-${index}-effect-select`}
              disabled={disabled}
              name={`_customTaints[${index}].effect`}
              label="Effect"
              options={Object.values(SelectionTemplateTaintEffect)}
              fieldProps={{
                defaultValue: SelectionTemplateTaintEffect.NoSchedule,
              }}
              applySortingWhileSearching={false}
            />
            {!isOnly && (
              <WhenMode mode={['edit', 'create']}>
                <IconButton
                  testId={`taint-pair-${index}-delete-button`}
                  variant="ghost"
                  onClick={() => remove()}
                  size="sm"
                  sx={{ alignSelf: 'flex-end' }}
                >
                  <Icons.X />
                </IconButton>
              </WhenMode>
            )}
          </Box>
        );
      }}
    />
  );
};
